import "./subscription-plan.scss";

const SubscriptionPlan: React.FC = () => {
  return (
    <div className="subscription-plan-wrapper">
      <div className="plan-intro">
        <span className="--small-text">Pricing plans</span>

        <span className="--big-text"> Introduce pricing plans</span>

        <span className="--medium-text">
          {" "}
          Simple, transparent pricing that grows with you. Try any plan free for
          30 days.
        </span>

        <div className="switch-button">
          <span>Monthly</span>
          <span>Yearly</span>
        </div>
      </div>

      <div className="plan-boxes">
        {/* Basic plan */}
        <div className="plan-boxes__item">
          <div className="--plan-box-top">
            <span className="--plan-medium-text">Basic plan</span>
            <span className="--plan-big-text">$19/ mo</span>
            <span className="--plan-small-text">or $199 yearly</span>
          </div>

          <div className="--box-bottom">
            <div className="--plan-box-bottom">
              <div className="--plan-box-bottom__icon">✓</div>
              <div className="--plan-box-bottom__text">
                Feature text goes here
              </div>
            </div>
            <div className="--plan-box-bottom">
              <div className="--plan-box-bottom__icon">✓</div>
              <div className="--plan-box-bottom__text">
                Feature text goes here
              </div>
            </div>
            <div className="--plan-box-bottom">
              <div className="--plan-box-bottom__icon">✓</div>
              <div className="--plan-box-bottom__text">
                Feature text goes here
              </div>
            </div>
          </div>

          <div className="get-started-button">
            <span>Get Started</span>
          </div>
        </div>

        {/* Business plan */}
        <div className="plan-boxes__item">
          <div className="--plan-box-top">
            <span className="--plan-medium-text">Business plan</span>
            <span className="--plan-big-text">$29/ mo</span>
            <span className="--plan-small-text">or $299 yearly</span>
          </div>

          <div className="--box-bottom">
            <div className="--plan-box-bottom">
              <div className="--plan-box-bottom__icon">✓</div>
              <div className="--plan-box-bottom__text">
                Feature text goes here
              </div>
            </div>
            <div className="--plan-box-bottom">
              <div className="--plan-box-bottom__icon">✓</div>
              <div className="--plan-box-bottom__text">
                Feature text goes here
              </div>
            </div>
            <div className="--plan-box-bottom">
              <div className="--plan-box-bottom__icon">✓</div>
              <div className="--plan-box-bottom__text">
                Feature text goes here
              </div>
            </div>
          </div>

          <div className="get-started-button">
            <span>Get Started</span>
          </div>
        </div>

        {/* Enterprise plan */}
        <div className="plan-boxes__item">
          <div className="--plan-box-top">
            <span className="--plan-medium-text">Enterprise plan</span>
            <span className="--plan-big-text">$49/ mo</span>
            <span className="--plan-small-text">or $499 yearly</span>
          </div>

          <div className="--box-bottom">
            <div className="--plan-box-bottom">
              <div className="--plan-box-bottom__icon">✓</div>
              <div className="--plan-box-bottom__text">
                Feature text goes here
              </div>
            </div>
            <div className="--plan-box-bottom">
              <div className="--plan-box-bottom__icon">✓</div>
              <div className="--plan-box-bottom__text">
                Feature text goes here
              </div>
            </div>
            <div className="--plan-box-bottom">
              <div className="--plan-box-bottom__icon">✓</div>
              <div className="--plan-box-bottom__text">
                Feature text goes here
              </div>
            </div>
            <div className="--plan-box-bottom">
              <div className="--plan-box-bottom__icon">✓</div>
              <div className="--plan-box-bottom__text">
                Feature text goes here
              </div>
            </div>
            <div className="--plan-box-bottom">
              <div className="--plan-box-bottom__icon">✓</div>
              <div className="--plan-box-bottom__text">
                Feature text goes here
              </div>
            </div>
          </div>

          <div className="get-started-button">
            <span>Get Started</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlan;
